import axios from "axios";
import { clearLogoutData } from "../../logout/action";
import { Documents_Master_Service_URL } from "../../Url";

export const uploadDocumentsActions = {
  UPLOAD_DOCUMENT_REQUEST: "UPLOAD_DOCUMENT_REQUEST",
  UPLOAD_DOCUMENT_LOADING: "UPLOAD_DOCUMENT_LOADING",
  UPLOAD_DOCUMENT_SUCCESS: "UPLOAD_DOCUMENT_SUCCESS",
  UPLOAD_DOCUMENT_ERROR: "UPLOAD_DOCUMENT_ERROR",
};

export const uploadDocuments = (props) => async (dispatch, getState) => {
  const accessToken = props.accessToken ?? getState()?.auth?.idToken;

  const { partnerFirmId, data } = props;
  dispatch(uploadDocumentsLoading());
  return axios({
    method: "post",
    url: `${Documents_Master_Service_URL}/uploadDocument`,
    headers: {
      authorization: "Bearer " + accessToken,
    },
    data,
    params: {
      partnerFirmId,
    },
  })
    .then((response) => {
      if (response.status >= 200 && response.status < 300) {
        dispatch(uploadDocumentsSuccess(response.data));
        return response;
      } else if (response.status === 401) {
        return response;
      } else {
        const error = new Error(response.statusText);
        dispatch(uploadDocumentsLoading(error));
        throw error;
      }
    })
    .catch((error) => {
      if (error.response) {
        dispatch(uploadDocumentsLoading(error));

        return error;
      }

      throw error;
    });
};

export function uploadDocumentsSuccess(props) {
  return (dispatch) => {
    dispatch({
      type: uploadDocumentsActions.UPLOAD_DOCUMENT_SUCCESS,
      payload: props,
    });
  };
}

export function uploadDocumentsLoading() {
  return {
    type: uploadDocumentsActions.UPLOAD_DOCUMENT_LOADING,
  };
}

export function uploadDocumentsError(error) {
  return {
    type: uploadDocumentsActions.UPLOAD_DOCUMENT_ERROR,
    payload: error,
  };
}
